import { useCallback, useMemo, useState, useEffect } from "react";
import useApi from "./useApi";

export const useFormSubmissions = () => {
  const api = useApi();

  const getUnreviewedSubmissionsCount = useCallback(
    async (formId: string): Promise<number> => {
      const response = await api.get(
        `/formsubmissions/unreviewed/${formId}/count`,
      );
      return response.data;
    },
    [api],
  );

  return useMemo(
    () => ({ getUnreviewedSubmissionsCount }),
    [getUnreviewedSubmissionsCount],
  );
};

export const useUnreviewedSubmissionsCount = (formId: string) => {
  const [count, setCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { getUnreviewedSubmissionsCount } = useFormSubmissions();

  useEffect(() => {
    const fetchCount = async () => {
      try {
        setLoading(true);
        setError(null);
        const result = await getUnreviewedSubmissionsCount(formId);
        setCount(result);
      } catch (err) {
        console.error("Error fetching unreviewed submissions count:", err);
        const message =
          err instanceof Error ? err.message : "Failed to load count";
        setError(message);
      } finally {
        setLoading(false);
      }
    };

    if (formId) {
      fetchCount();
    }
  }, [formId, getUnreviewedSubmissionsCount]);

  return { count, loading, error };
};
